import { ITrainingPlanProgressData } from "@hooks/game/training-plans/training-plans-shared";

export interface ITrainingPlanModel {
  completedSessionsCount: number;
  requiredSessionsCount: number;
  currentStreakCount: number;
  showStreak: boolean;
  isComplete: boolean;
}

export const buildTrainingPlanModel = (
  progressData: ITrainingPlanProgressData | null,
): ITrainingPlanModel | null => {
  if (!progressData?.current_period) {
    return null;
  }

  const completedSessionsCount = progressData.current_period.completed_sessions_count;
  const requiredSessionsCount = progressData.current_period.required_sessions_count;
  const isComplete = progressData.current_period.is_completed || completedSessionsCount >= requiredSessionsCount;

  return {
    completedSessionsCount,
    requiredSessionsCount,
    currentStreakCount: progressData.enrollment.current_streak_count,
    showStreak: progressData.enrollment.current_streak_count >= 2,
    isComplete,
  };
};